export default class Bus {
  _events: Record<string, Function[]> = {};

  $on(event: string, fn: Function) {
    (this._events[event] || (this._events[event] = [])).push(fn);
  }

  $emit(event: string, ...args: any) {
    const fns = this._events[event];
    if (!fns || fns.length === 0) return;
    fns.forEach((fn) => {
      fn.apply(this, args);
    });
  }
}
